import { ImportOrdersStep } from './import-orders';

// Step Groupnames
export const ORDERS_PAGE_COACHMARKS = 'ORDERS_PAGE_COACHMARKS';

// Actual steps for Joyride
export const StepLookup = {
  ORDERS_PAGE_COACHMARKS: [ImportOrdersStep],
};
